import React from 'react';
import { LinearProgress } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import classes from './Progress.module.scss';

const Progress = () => {
  const { t } = useTranslation();
  return (
    <div className={classes.progress}>
      <LinearProgress className={classes.bar} />
      <div className={classes.loadingText}>
        {t('Onboarding.MerchantOnboarding.documentationForm.uploadStatus')}
      </div>
    </div>
  );
};

export default Progress;
